export default __webpack_public_path__ + "images/OA.6c4a208.png";